import { Card } from "@/components/layout";
import {
  PanelError,
  PanelLoading,
  SectionHeading,
} from "@/components/dashboard";
import { HorizontalBarList } from "@/components/charts";
import { useGa4TopEvents, useGa4TopPages } from "@/hooks/useGa4";
import type { TimeRange } from "@/lib/time-range";

interface Props {
  range: TimeRange;
}

/** The full GA4 event taxonomy + most-viewed pages. */
export function Ga4EngagementSection({ range }: Props) {
  const events = useGa4TopEvents(range);
  const pages = useGa4TopPages(range);

  return (
    <section className="flex flex-col gap-3">
      <SectionHeading
        title="GA4 Engagement"
        source="ga4"
        description="What visitors actually do and which pages they spend time on. Events include scroll depth, performance timings (LCP, TTFB), and every tracked interaction; pages are ranked by total views."
      />

      <div className="grid gap-4 lg:grid-cols-2">
        <Card title="Top events">
          {events.isLoading ? <PanelLoading />
            : events.error ? <PanelError error={events.error} onRetry={() => events.refetch()} />
            : <HorizontalBarList tone="amber" limit={12}
                entries={(events.data?.events ?? []).map((e) => ({ label: e.name, value: e.count }))} />}
        </Card>

        <Card title="Top pages by views">
          {pages.isLoading ? <PanelLoading />
            : pages.error ? <PanelError error={pages.error} onRetry={() => pages.refetch()} />
            : <HorizontalBarList tone="sky" limit={12}
                entries={(pages.data?.pages ?? []).map((p) => ({ label: p.path, value: p.views }))} />}
        </Card>
      </div>
    </section>
  );
}
